import { Record, Set } from 'immutable';

export const CoreSliceKey = 'main';
export interface ICoreOriginalSliceState {
	isAdmin: boolean;
	currentUserId: string;
}

const stateDefaults: ICoreOriginalSliceState = {
	isAdmin: false,
	currentUserId: '',
};

export class CoreOriginalSliceState extends Record<ICoreOriginalSliceState>(
	stateDefaults
) {
	public static readonly key = CoreSliceKey;

	public setIsAdmin(val: boolean): CoreOriginalSliceState {
		return this.set('isAdmin', val);
	}

	public setCurrentUserId(val: string): CoreOriginalSliceState {
		return this.set('currentUserId', val);
	}
}
